import { Link, useRouterState } from '@tanstack/react-router'
import { cn } from '@app/lib/cn'

/**
 * The finans module's screens, as a slim tab strip both screens render.
 * Plain links — the guard lives on the routes and the Worker, not here.
 */
const TABS = [
  { to: '/finans', label: 'Çek Takvimi' },
  { to: '/finans/tahsilat', label: 'Tahsilat' },
] as const

export function FinansTabs() {
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  return (
    <nav aria-label="Finans ekranları" className="flex gap-1 border-b border-hairline">
      {TABS.map((tab) => {
        const active = tab.to === '/finans' ? pathname === '/finans' : pathname.startsWith(tab.to)
        return (
          <Link
            key={tab.to}
            to={tab.to}
            aria-current={active ? 'page' : undefined}
            className={cn(
              '-mb-px border-b-2 px-3 py-1.5 text-data transition-colors',
              active
                ? 'border-kordovan font-medium text-ink'
                : 'border-transparent text-ink-muted hover:text-ink',
            )}
          >
            {tab.label}
          </Link>
        )
      })}
    </nav>
  )
}
